export default __webpack_public_path__ + "static/media/cta-background.420a4b12.png";